// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable, retry} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from './configuration-service';
import {IRestConfig} from '../types/config';
import {API_URL} from '../shared/api';

@Injectable({
    providedIn: 'root'
})
export class RestConfigService {

    constructor(
        private http: HttpClient,
        private translate: TranslateService,
        private configurationService: ConfigurationService) { }

    getUrl(suffix: string) {
        return `${this.configurationService.apiUrl}${suffix}`;
    }

    getRestConfig(): Observable<IRestConfig> {
        const url = this.getUrl(`${API_URL.API_CONFIG}`);
        return this.http.get<IRestConfig>(url)
            .pipe(retry({
                delay: 5000,
            }));
    }
}
